const scopes = {
  utilities: "maintenance-utilities",
};

export const MaintenanceKeys = {
  utilities: {
    all: () => [scopes.utilities] as const,
  },
};
